import api from './api-caller';
import utils from '../mixins/utils';
const { getOrganizationPublicId, getUserScreenName } = utils.methods;

const baseEndpoint = '/organizations';


export default {
    listProjects: (groupBy = 'name') => {
        let endpoint = `${baseEndpoint}/${getOrganizationPublicId()}/projects?groupBy=${groupBy}`
        return api(endpoint, 'GET')
    }, 

    getCurrentUserProjects: () => {
        let endpoint = `${baseEndpoint}/${getOrganizationPublicId()}/projects?user=${getUserScreenName()}`;
        return api(endpoint, 'GET')
    }
}
